export const DEFAULT_FORM_NAME = 'REGISTRATION';
export const DYNAMIC_REGISTRATION = 'dynamic-registration';
